import React from 'react';
import { Chip, Hidden, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { FaFilter } from 'react-icons/fa';
import { FilterItemSkeleton } from '../Skeletons/FilterItemSkeleton';
import FilterItem from '../FilterItem';

import { useStyles } from './styles';

interface FiltersListProps {
  loading: boolean;
  filterLabel: string;
  type: 'effective_sizing' | 'relevance_analysis';
  data: any;
  activeFilters: string[];
  temporaryFilters: string[];
  onChange: () => void;
  onChangeFilter: (name: string, active: boolean) => void;
}

const FiltersList: React.FC<FiltersListProps> = ({
  loading,
  filterLabel,
  type,
  data,
  activeFilters,
  temporaryFilters,
  onChange,
  onChangeFilter,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Hidden smDown>
      <div className={classes.container}>
        <div className={classes.header}>
          <Typography
            variant="h2"
            className={classes.title}
            style={{ marginRight: 32 }}
          >
            {t('screens:dimensioning.assets')}
          </Typography>
          <Chip
            label={filterLabel}
            variant="outlined"
            className={classes.filterChip}
            icon={<FaFilter color="#9DA5B1" size={16} />}
            onClick={onChange}
          />
        </div>
        {loading
          ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16].map(val => (
              <FilterItemSkeleton key={val} />
            ))
          : data.map((equipment: any) => {
              return (
                <FilterItem
                  key={equipment.id}
                  type={type}
                  checked={
                    activeFilters.includes(equipment.name) ||
                    temporaryFilters.includes(equipment.name)
                  }
                  data={equipment}
                  onChange={(name, active) => onChangeFilter(name, active)}
                />
              );
            })}
      </div>
    </Hidden>
  );
};

export default FiltersList;
